import { DeleteVideoAction } from './video-placement.types';

export type VideoArchivedFilter = 'hide' | 'show';

export enum VideoListFilterField {
  status = 'status',
  placement = 'placement',
  title = 'title',
  archived = 'archived',
}

export interface VideoListFilterValues {
  status: string | null;
  placement: string | null;
  title: string;
  archived: VideoArchivedFilter;
}

export interface VideoLibraryLocationState {
  deleted?: DeleteVideoAction;
}
